import { render, staticRenderFns } from "./OrderAgainInfo.vue?vue&type=template&id=440aaebe&scoped=true"
import script from "./OrderAgainInfo.vue?vue&type=script&lang=js"
export * from "./OrderAgainInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440aaebe",
  null
  
)

export default component.exports